import React from "react";
import { connect } from "react-redux";
import { get, map } from "lodash";

import { withStyles } from "@material-ui/styles";
import Checkbox from "@material-ui/core/Checkbox";

import { I18n } from "@aws-amplify/core";

import images from "../../assets/img/images";
import { roundForJrv } from "../../utils/precision";

const styles = {
    unitBlock: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        lineHeight: 1.143,
        width: "100%",
        border: "1px solid #dddddd",
        borderRadius: 4,
        "&:not(:last-child)": {
            marginBottom: 16
        }
    },
    unitBlockViewMode: {
        padding: "4px 8px",
    },
    willDisplay: {
        fontStyle: "italic"
    },
    unitIsDisplay: {
        padding: 2,
        width: 14,
        marginRight: 8,
        "& img": {
            width: 14,
            height: 14
        }
    }

};

const PziUnitsList = withStyles(styles)((props, ref) => {
    const {
        classes,
        // language,
        isEditMode,
        pziUnits,
        productUnits,
        setPziUnits,
        baseUOM,
    } = props;

    const [units, setUnits] = React.useState();
    const [sortedUnits, setSortedUnits] = React.useState();

    React.useEffect(() => {
        // Need to unspool the product Units into an assoc array.
        let _productUnits = JSON.parse(productUnits);
        let _units = {}
        if (_productUnits && _productUnits['units'] && _productUnits['units'].length > 0) {
            for (let i = 0; i < _productUnits['units'].length; i++) {
                // Note: it's possible for some json's to have 'code' instead of 'bc_code'
                // due to a lack of will to clean up old data from old syncs.
                let bc_code = 'bc_code' in _productUnits['units'][i] ? _productUnits['units'][i]['bc_code'] : _productUnits['units'][i]['code'];
                _units[bc_code] = _productUnits['units'][i];
                _units[bc_code]['isDisplay'] = false;
            }
        }
        if (pziUnits) {
            let _pziUnits = JSON.parse(pziUnits);
            if (_pziUnits && _pziUnits['units'] && _pziUnits['units'].length > 0) {
                for (let i = 0; i < _pziUnits['units'].length; i++) {
                    let bc_code = 'bc_code' in _pziUnits['units'][i] ? _pziUnits['units'][i]['bc_code'] : _pziUnits['units'][i]['code'];
                    // Prior to the fix of setting the defaults on product replacements
                    // we need to support the case where the current set units do not mach
                    // the allowable units.  Once set and saved, this should correct itself.
                    if (bc_code in _units) _units[bc_code]['isDisplay'] = true;
                }
            }
        }
        setUnits(_units);
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pziUnits]); // Only once or when pziUnits and productUnits change? - think only once...

    React.useEffect(() => {
        if (units) {
            let _sortedUnits = Object.values(units);
            _sortedUnits.sort((a, b) => {return a['quantity'] - b['quantity'];});
            setSortedUnits(_sortedUnits);
        }
    }, [units]);

    const hanldeToggleUnitDisplay = (key, value) => {
        let newUnits = {
            ...units,
            [key]: {
                ...units[key],
                isDisplay: value
            } 
        };
        setUnits(newUnits);
        repackageUnits(newUnits);
    };

    const repackageUnits = (newUnits) => {
        let _productUnits = JSON.parse(JSON.stringify(Object.values(newUnits)));
        let pziUnits = {"units": []};
        for (let i = 0; i < _productUnits.length; i++) {
            if (_productUnits[i]['isDisplay']) {
                delete _productUnits[i]['isDisplay'];
                pziUnits['units'].push(_productUnits[i]);
            }
        }
        let jsonPziUnits = JSON.stringify(pziUnits);
        setPziUnits(jsonPziUnits);
    };

    return (
        <>
        {map(sortedUnits, (unit, i) =>(
            <div key={i} className={ isEditMode? classes.unitBlock : `${classes.unitBlock} ${classes.unitBlockViewMode}`}>
                { isEditMode ?
                    <div >
                        <Checkbox
                            color="primary"
                            checked={unit['isDisplay']}
                            onChange={e => hanldeToggleUnitDisplay(unit['bc_code'], e.target.checked)}
                        />
                    </div>
                :
                    <div className={classes.unitIsDisplay}>
                        {unit['isDisplay'] ? <img alt="Green Checkmark" src={images.check_green} /> : <></>}
                    </div>
                }
                <div>
                    <div>Bc_code: {'bc_code' in unit ? unit['bc_code'] : unit['code']}, {I18n.get("quantity")} {roundForJrv(unit['quantity'], baseUOM)}</div>
                    <div><span className={classes.willDisplay}>{I18n.get("pzi_units_will_be_displayed")}</span> : &quot;x {roundForJrv(unit['quantity'], baseUOM)}&quot;</div>
                </div>
            </div>
        ))}
        </>
        
    );
});

const mapStateToProps = (state) => {
    return {
        language: get(state, ["user", "language"])
    };
};

export default connect(mapStateToProps)(PziUnitsList);